export default function Footer(){
    return (
        <div className="footer container">
            <div className="footer-section">
                <p className="title">MiddleEats.com</p>
                <p>MiddleEats is a non-profit platform connecting Middle Eastern cuisine admirers, across the globe.</p>
                <p>&copy; 2022 | All Rights Reserved</p>
            </div>
            <div className="footer-section">
                <p className="title">Contact Us</p>
                <p>middle.eats@gmail.com</p>
                <p>+965-1234-9876</p>
                <p>2393 Messila KW</p>
            </div>
            <div className="footer-section">
                <p className="title">Socials</p>
                <p>Facebook</p>
                <p>Twitter</p>
                <p>Instagram</p>
            </div>
        </div>
    )
}